module.exports = __webpack_public_path__ + "img/pageBanner-activityExtension.0d88fc05.jpg";